export default "__VITE_ASSET__DKXYLr3q__"